import { ocapiV1Routes } from '../routes';
export const paymentsApiRoutes = {
    masterData: {
        webPaymentMethods: {
            get: ()=>`${ocapiV1Routes.prefix}/web-payment-methods`
        }
    }
};

//# sourceMappingURL=routes.js.map